import * as React from 'react';

import { Button } from '../Button';

export interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
  id?: string;
  children: string;
  disabled?: boolean;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

const defaultProps: Partial<IProps> = {
  ariaLabel: undefined,
  disabled: false,
  onClick: () => void 0,
  type: 'button',
};

const ConfirmButton: React.SFC<IProps> = (props) => (
  <Button
    ariaLabel={props.ariaLabel}
    color="primary"
    disabled={props.disabled}
    id={props.id}
    onClick={props.onClick}
    type={props.type}
  >
    {props.children}
  </Button>
);

ConfirmButton.defaultProps = defaultProps;
export default ConfirmButton;
